import React, { memo } from 'react';

import { fixedPercentFigure } from '../../utils/percentFigure';

import { formatFigure, formatToFixedMoneyWithLocale } from 'Helpers/formatService';

import Tooltip from 'CommonComponents/Tooltip';

const GenericMilestoneData = memo(function GenericMilestoneData(props) {
    const { milestones, milestoneId, amountOnly = false, isCommitted = false, showTooltip = true } = props;

    const tooltipContent = () => {
        return milestones[milestoneId] ? milestones[milestoneId].name || '' : '';
    };

    const milestone = milestones[milestoneId];
    const hasValidMilestone = milestoneId in milestones && milestone;
    const hasAmount = hasValidMilestone && milestone.amount;
    const hasPercentage = hasValidMilestone && milestone.percentage;
    // A month with no phasing is a real zero, so it shows the dash rather than a blank.
    const amountText = formatFigure(hasAmount ? milestone.amount : 0, formatToFixedMoneyWithLocale, { precision: 2 });

    // For amountOnly mode (used in parent rows)
    if (amountOnly) {
        return (
            <>
                <td></td>
                <td className="tw-text-right">
                    {showTooltip && hasValidMilestone ? (
                        <Tooltip
                            placement="bottom-start"
                            tooltipContent={tooltipContent()}
                            backgroundClass="tw-bg-blue"
                            tooltipType="text"
                            offset={[16, -10]}
                            allowTooltip={!!tooltipContent()}
                        >
                            <span className="tw-cursor-pointer">{amountText}</span>
                        </Tooltip>
                    ) : (
                        amountText
                    )}
                </td>
            </>
        );
    }

    // For full display mode (percentage + amount)
    return (
        <>
            <td className="tw-text-right">{(!amountOnly || isCommitted) && hasPercentage ? fixedPercentFigure(milestone.percentage) : ''}</td>
            <td className="tw-text-right">
                {showTooltip && hasValidMilestone ? (
                    <Tooltip
                        placement="bottom-start"
                        tooltipContent={tooltipContent()}
                        backgroundClass="tw-bg-blue"
                        tooltipType="text"
                        offset={[16, -10]}
                        allowTooltip={!!tooltipContent()}
                    >
                        <span className="tw-cursor-pointer">{amountText}</span>
                    </Tooltip>
                ) : (
                    amountText
                )}
            </td>
        </>
    );
});

export default GenericMilestoneData;
